import { Component, OnInit } from '@angular/core';


@Component({
    selector: 'app-tax-certificate-manual',
    templateUrl: './tax-certificate-manual.component.html',
    styleUrls: ['./tax-certificate-manual.component.css'],
    standalone: false
})
export class TaxCertificateManualComponent implements OnInit {

  pdfSrcEN = "assets/user-manual/Tax-Certificate-Manual V1.2.pdf"

  constructor() { }

  ngOnInit(): void {
  }

  afterLoadComplete(event){
  }

}
